import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const GraphicConnections = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.user_type;

  const [buyerId, setBuyerId] = useState(() => {
    return localStorage.getItem("graphic_designer_id");
  });

  const handleRowClick = (id) => {
    const newId = buyerId === id ? null : id;
    setBuyerId(newId);

    if (newId) {
      localStorage.removeItem("buyer_id");
      // localStorage.setItem("buyer_id", newId);
    } else {
      localStorage.removeItem("buyer_id");
    }
  };

  const isAlertShown = useRef(false);
  useEffect(() => {
    if (location.state && !isAlertShown.current) {
      toast.success(location.state);
      isAlertShown.current = true;
      window.history.replaceState({}, null);
    }
  }, [location.state]);

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const monthQuery = monthFilter ? `&month=${monthFilter}` : "";

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const SupplierLeadData = () => {
    const monthQuery = monthFilter ? `&month=${monthFilter}` : "";

    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/graphic_designer?page=${page}&search=${search}${monthQuery}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        let users = res?.data?.data?.designers || [];

        users = users.filter((u) => u.status === "active");

        setTotalPage(res?.data?.data?.pages);
        setData(users);
      })
      .catch((err) => {
        if (err?.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, "supplier-buy-lead.xlsx");
  };

  useEffect(() => {
    SupplierLeadData();
  }, [page, search, monthFilter]);

  const initialsOf = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const TINTS = [
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tint = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const fmt = (d) =>
    d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) : "—";

  const [dense, setDense] = useState(false);
  const [sortDir, setSortDir] = useState("");
  const [isMobileView, setIsMobileView] = useState(typeof window !== "undefined" && window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  let displayData = [...(data || [])];
  if (sortDir) {
    displayData.sort((a, b) => {
      const av = (a?.name || "").toLowerCase();
      const bv = (b?.name || "").toLowerCase();
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  }

  const viewState = (item) => ({
    state: {
      id: item?.id, name: item?.name, company_name: item?.company_name,
      designation: item?.designation, status: item?.is_active, email: item?.email,
      country: item?.country, city: item?.city, created_at: item?.created_at,
      gst_number: item?.gst_number, phone: item?.phone, state: item?.state,
      address: item?.address, pincode: item?.pincode, user_type: item?.user_type,
    },
  });

  const GRID = { gridTemplateColumns: "1.6fr 1.8fr 1.1fr 1.1fr 118px" };

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Designer Connections</h1>
          <p className="al-sub">Designers connected to orders and their contact details.</p>
        </div>
        <div className="al-head__actions">
          {userType === "admin" && (
            <button type="button" className="al-btn al-btn--primary" onClick={exportToExcel}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Export
            </button>
          )}
        </div>
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search connections…"
              onKeyDown={(e) => e.key === "Enter" && search !== "" && SupplierLeadData()}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="al-select">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <select value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)}>
              <option value="">Select Month</option>
              <option value="All">All</option>
              <option value="1">Last 1 Month</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
            </select>
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        {!isMobileView ? (
          <div className="al-tablewrap">
            <div style={{ minWidth: 920, "--al-row-pad": dense ? "8px" : "13px" }}>
              <div className="al-thead" style={GRID}>
                <span className="al-th al-th--sort" onClick={() => setSortDir((d) => (d === "asc" ? "desc" : d === "desc" ? "" : "asc"))}>
                  Name
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: sortDir ? 1 : 0.45, transform: sortDir === "desc" ? "rotate(180deg)" : "none" }}><polyline points="18 15 12 9 6 15"/></svg>
                </span>
                <span className="al-th">Email</span>
                <span className="al-th">Mobile Number</span>
                <span className="al-th">Date &amp; Time</span>
                <span className="al-th al-th--right">Action</span>
              </div>

              {displayData && displayData.length > 0 ? (
                displayData.map((item, index) => {
                  const t = tint(item?.name);
                  const active = buyerId === String(item?.user_id);
                  return (
                    <div className="al-row" style={{ ...GRID, background: active ? "var(--color-primary-weak)" : undefined, cursor: "pointer" }} key={index}
                      onClick={() => handleRowClick(item?.user_id)}>
                      <div className="al-id">
                        <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(item?.name)}</span>
                        <span className="al-name">{item?.name}</span>
                      </div>
                      <span className="al-muted al-ellipsis" title={item?.email}>{item?.email}</span>
                      <span className="al-mono al-muted">{item?.phone}</span>
                      <span className="al-mono al-muted">{fmt(item?.created_at)}</span>
                      <div className="al-actions">
                        <button type="button" className="al-act" title="View"
                          onClick={(e) => { e.stopPropagation(); Navigate(`/admin/graphic-designer/show/${item?.user_id}`, viewState(item)); }}>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="al-empty">
                  <div className="al-empty__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                  </div>
                  <p className="al-empty__title">No Record Found</p>
                  <p className="al-empty__text">Active designer connections will appear here.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="al-mobile">
            {displayData && displayData.length > 0 ? (
              displayData.map((item, index) => {
                const t = tint(item?.name);
                const active = buyerId === String(item?.user_id);
                return (
                  <div className="al-mcard" key={index} style={{ background: active ? "var(--color-primary-weak)" : undefined }}
                    onClick={() => handleRowClick(item?.user_id)}>
                    <div className="al-mcard__top">
                      <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(item?.name)}</span>
                      <div className="al-name" style={{ flex: 1 }}>{item?.name}</div>
                    </div>
                    <div className="al-mrow"><span className="al-muted">Email</span><span>{item?.email}</span></div>
                    <div className="al-mrow"><span className="al-muted">Mobile</span><span className="al-mono">{item?.phone}</span></div>
                    <div className="al-mrow"><span className="al-muted">Date</span><span className="al-mono al-muted">{fmt(item?.created_at)}</span></div>
                    <div className="al-mactions">
                      <button type="button" className="al-act" title="View"
                        onClick={(e) => { e.stopPropagation(); Navigate(`/admin/graphic-designer/show/${item?.user_id}`, viewState(item)); }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="al-empty"><p className="al-empty__title">No Record Found</p></div>
            )}
          </div>
        )}

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{displayData?.length || 0}</strong> connections</span>
          {data?.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default GraphicConnections;
